<script>
  import { api_url, path } from "../ConfigService.js";
  
  export let dataCart;
  export let orderno;
  export let file;
  export let photoId;
  export let variant;
  export let count = 0; 
  
  async function updateCart(c) {

	const resp = await fetch($api_url+'?addToCart=true&album=last&key='+orderno, {
		method: 'POST',
		body: JSON.stringify({
			file,
			id: photoId,
			variant: [ variant ],
			selected: [ count ]
		})
	});
	dataCart=await resp.json();
  }
  
  function increment() {
    count++;
    updateCart(count);
  }

  function decrement() {
    if (count > 0) count--; 
    updateCart(count);
  }
  
  function isActiveMinus(c) {
  	if (c <= 0) { return "inactive"; }
  	return "";
  }
  function isActivePlus(c) {
  	if (c > 100) { return "inactive"; }
  	return "";
  }
</script>

<div class="counter">
  <button on:click={decrement} class="{isActiveMinus(count)}">−</button>
  <input type="number" bind:value={count} min="0" max="100" on:change={updateCart(count)} />
  <button on:click={increment} class="{isActivePlus(count)}">+</button>
</div>

<style>
  .counter {
    display: flex;
    align-items: center;
    gap: 5px;
  }
 
  .inactive {
  	color:silver;
  	cursor:default;
  }

  input {
    width: 50px;
    text-align: center;
  }

  button {
    padding: 5px 10px;
    font-size:150%;
    font-weight:bold;
  }
  
  input[type="number"] {
  	-moz-appearance: textfield; /* Firefox */
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
	  -webkit-appearance: none; /* Chrome, Edge, Safari */
	  margin: 0;
  }

</style>

